import { alpha, hexToRgb } from '@mui/system';

import { styled } from 'helpers';

import { EditableProps } from './types';

export const Editable = styled('div', {
  shouldForwardProp: (prop) => prop !== 'avatarSize',
})<EditableProps>`
  align-items: center;
  border-radius: 50%;
  color: ${({ theme }) => theme.palette.common.white};
  cursor: pointer;
  display: flex;
  font-size: ${({ theme, avatarSize }) => {
    const fontSizeMap: { [s: number]: number } = {
      24: 8,
      32: 10,
      48: 14,
      56: 16,
      88: 24,
      120: 32,
    };
    return theme.typography.pxToRem(fontSizeMap[avatarSize]);
  }};
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;

  svg {
    display: none;
    filter: drop-shadow(0 4px 4px rgb(0 0 0 / 0.25));
  }

  :hover {
    background: ${({ theme }) => alpha(hexToRgb(theme.palette.common.black), 0.32)};
  }

  :hover svg {
    display: block;
  }
`;

export default Editable;
